import React from "react";
import {Box, useTheme} from "@mui/material";
import {LoadingButton} from "@mui/lab";

interface AdvancedFiltersButtonProps {
    count: number;
    onClick: () => void;
}

/** Botão "Filtros Avançados" com o contador de filtros aplicados, que abre o painel lateral. */
export const AdvancedFiltersButton: React.FC<AdvancedFiltersButtonProps> = ({count, onClick}) => {
    const theme = useTheme();

    return (
        <LoadingButton
            size="small"
            sx={{lineHeight: 1, height: '37px'}}
            loading={false}
            startIcon={
                <Box
                    sx={{
                        color: theme.palette.primary.main,
                        backgroundColor: '#fff',
                        fontSize: '0.75rem !important',
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {count}
                </Box>
            }
            variant="contained"
            onClick={onClick}
        >
            Filtros Avançados
        </LoadingButton>
    );
};
